import React from 'react';
import TopBar from '../components/topBar/TopBar';
import GearPage from './GearPage';
import GearGrid from '../components/grid/GearGrid';
import { Footer } from '../components/Footer';
import { GearDocumentForm } from '../components/common/form/GearDocumentForm';

const MainPage: React.FC = () => {
  return (
    <GearPage>
      <TopBar />
      <GearGrid />
      <GearDocumentForm />
      <Footer />
    </GearPage>
  );
};

export default MainPage;
